/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgOracleO = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M16.05 5C19.898 5 23 8.135 23 12.002 23 15.868 19.898 19 16.05 19l-8.09-.003c-3.844 0-6.96-3.129-6.96-6.995C1 8.135 4.116 5 7.96 5zm-.184 2.474H8.139c-2.487 0-4.503 2.023-4.503 4.528 0 2.5 2.016 4.531 4.503 4.531h7.727c2.494 0 4.508-2.03 4.508-4.531a4.513 4.513 0 0 0-4.508-4.528z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgOracleO as OracleO };
